import { REMOVE_RELATED_THUMBNAIL } from "../reducers/actiontypes";

export let removeRelatedThumbnail = function(index) {
	return {
		type: REMOVE_RELATED_THUMBNAIL,
		index: index
	};
}
